/* Martha's World — NOCTURNE
   Seasonal scroll moods (spring → summer → fall → winter, cycling every ~screen),
   pixel weather (petals · sun glints · leaves · snow), season badge, pixel progress bar. */
(function () {
  'use strict';
  var REDUCE = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var ROOT = document.documentElement;

  /* base top · base bottom · glow A · glow B · accent — dark, moody, with plush-color hints; ch = screen-edge / phone toolbar color */
  var SEASONS = [
    { n: 'Spring', k: 'petal', c: ['#170d30', '#38154f', '#ff86c3', '#6fd0ff', '#ffb3dc'], ch: '#3a1661' },
    { n: 'Summer', k: 'glint', c: ['#07123f', '#163290', '#ff7a59', '#ffcf4d', '#ffd66b'], ch: '#173a9c' },
    { n: 'Fall',   k: 'leaf',  c: ['#1c0a10', '#47182a', '#ff8a3d', '#c2386e', '#ffae62'], ch: '#4a1830' },
    { n: 'Winter', k: 'flake', c: ['#06061a', '#1d1946', '#b3a2ff', '#5cd0ff', '#c4ecff'], ch: '#1e1958' }
  ];
  var VARS = ['--ma', '--mb', '--mc', '--md', '--acc'];
  var SEG = 0.85; /* one season per 0.85 screens of scroll */
  /* phones + tablets: one long painted gradient that scrolls with the page (no per-frame recolor = no flicker) */
  var LONGQ = window.matchMedia ? window.matchMedia('(max-width: 900px), (hover: none) and (pointer: coarse)') : null;
  function isLong() { return !!(LONGQ && LONGQ.matches); }
  ROOT.classList.toggle('mw-long', isLong());

  /* pixel sprites: '.' empty, 'a' main, 'b' second, 'c' highlight */
  var SPR = {
    petal: { m: ['.a.', 'aca', '.a.'], pal: [['#ffb3d9', '', '#fff1a6'], ['#ff8fc8', '', '#ffe9a8'], ['#ffd1ea', '', '#ffd66b'], ['#d9c2ff', '', '#fff1a6']] },
    glint: { m: ['..a..', '..a..', 'aacaa', '..a..', '..a..'], pal: [['#ffd66b', '', '#ffffff'], ['#ff9a6b', '', '#fff4d6'], ['#ffe9a8', '', '#ffffff']] },
    leaf:  { m: ['..aa', '.aab', 'aab.', 'ab..'], pal: [['#ff8a3d', '#7a2e14'], ['#ffb347', '#8a3a1a'], ['#e0502f', '#5e1d0e'], ['#c2386e', '#5a1530']] },
    flake: { m: ['..a..', 'a.a.a', '.aaa.', 'a.a.a', '..a..'], pal: [['#eaf6ff'], ['#c4ecff'], ['#d9d2ff']] }
  };

  function hex(h) { h = h.replace('#', ''); var n = parseInt(h, 16); return [n >> 16 & 255, n >> 8 & 255, n & 255]; }
  function mixv(a, b, t) { return Math.round(a[0] + (b[0] - a[0]) * t) + ',' + Math.round(a[1] + (b[1] - a[1]) * t) + ',' + Math.round(a[2] + (b[2] - a[2]) * t); }
  function clamp(v, a, b) { return v < a ? a : v > b ? b : v; }
  function rand(a, b) { return a + Math.random() * (b - a); }
  SEASONS.forEach(function (s) { s.rgb = s.c.map(hex); });

  function sprite(kind, pi, flip) {
    var d = SPR[kind], m = d.m, p = d.pal[pi], w = m[0].length, h = m.length;
    var c = document.createElement('canvas'); c.width = w; c.height = h;
    var x = c.getContext('2d');
    for (var r = 0; r < h; r++) for (var q = 0; q < w; q++) {
      var ch = m[r].charAt(flip ? w - 1 - q : q), col = ch === 'a' ? p[0] : ch === 'b' ? (p[1] || p[0]) : ch === 'c' ? (p[2] || p[0]) : '';
      if (col) { x.fillStyle = col; x.fillRect(q, r, 1, 1); }
    }
    return c;
  }
  var SHEET = {};
  Object.keys(SPR).forEach(function (k) {
    SHEET[k] = SPR[k].pal.map(function (_, i) { return [sprite(k, i, false), sprite(k, i, true)]; });
  });

  function init() {
    var bg = document.createElement('div'); bg.className = 'mw-moodbg'; bg.setAttribute('aria-hidden', 'true');
    document.body.insertBefore(bg, document.body.firstChild);
    var bar = document.createElement('div'); bar.className = 'mw-pixbar'; bar.setAttribute('aria-hidden', 'true');
    document.body.appendChild(bar);

    /* season badge */
    var badge = document.createElement('div'); badge.className = 'mw-season'; badge.setAttribute('aria-hidden', 'true');
    badge.innerHTML = '<canvas width="15" height="15"></canvas><span class="mw-season__name"></span><b class="mw-season__dots"><i></i><i></i><i></i><i></i></b>';
    document.body.appendChild(badge);
    var bIco = badge.querySelector('canvas'), bCtx = bIco.getContext('2d'), bName = badge.querySelector('.mw-season__name'), bDots = badge.querySelectorAll('.mw-season__dots i');
    bCtx.imageSmoothingEnabled = false;

    var tc = null;
    var state = { cur: 0, nxt: 1, t: 0, dom: -1 };
    function setBadge(i) {
      var s = SEASONS[i], spr = SHEET[s.k][0][0];
      bCtx.clearRect(0, 0, 15, 15);
      var u = Math.floor(15 / Math.max(spr.width, spr.height));
      bCtx.drawImage(spr, Math.floor((15 - spr.width * u) / 2), Math.floor((15 - spr.height * u) / 2), spr.width * u, spr.height * u);
      bName.textContent = s.n;
      for (var d = 0; d < bDots.length; d++) bDots[d].className = d === i ? 'on' : '';
      ROOT.setAttribute('data-season', s.n.toLowerCase());
      if (tc) setChrome(i);
      badge.classList.remove('is-flip'); void badge.offsetWidth; badge.classList.add('is-flip');
    }

    var ticking = false, lastY = window.scrollY, lastVals = [];
    function blend(cur, nxt, t) {
      var A = SEASONS[cur].rgb, B = SEASONS[nxt].rgb;
      for (var v = 0; v < VARS.length; v++) { var val = mixv(A[v], B[v], t); if (lastVals[v] !== val) { lastVals[v] = val; ROOT.style.setProperty(VARS[v], val); } }
      state.cur = cur; state.nxt = nxt; state.t = t;
      var dom = t < 0.5 ? cur : nxt;
      if (dom !== state.dom) { state.dom = dom; setBadge(dom); }
    }
    /* long mode: colors follow the painted gradient under mid-screen, eased so fast flicks never flash */
    var STOPS = [0.07, 0.35, 0.62, 0.91], ease = { pos: -1, target: 0, raf: 0, last: 0 };
    function longPos(f) { if (f <= STOPS[0]) return 0; for (var k = 1; k < 4; k++) if (f <= STOPS[k]) return k - 1 + (f - STOPS[k - 1]) / (STOPS[k] - STOPS[k - 1]); return 3; }
    function applyPos(pos) { var i = Math.min(2, Math.floor(pos)), t = pos - i; blend(i, i + 1, t * t * (3 - 2 * t)); }
    function step(now) {
      var dt = ease.last ? Math.min(0.05, (now - ease.last) / 1000) : 0.016; ease.last = now;
      ease.pos += (ease.target - ease.pos) * (1 - Math.exp(-dt * 2.6));
      if (Math.abs(ease.target - ease.pos) < 0.002) ease.pos = ease.target;
      applyPos(ease.pos);
      ease.raf = ease.pos === ease.target ? 0 : requestAnimationFrame(step);
    }
    function update() {
      ticking = false;
      var vh = window.innerHeight, y = window.scrollY, docH = document.documentElement.scrollHeight;
      if (isLong()) {
        ease.target = longPos(clamp((y + vh * 0.5) / Math.max(1, docH), 0, 1));
        if (ease.pos < 0) { ease.pos = ease.target; applyPos(ease.pos); }
        else if (!ease.raf && ease.pos !== ease.target) { ease.last = 0; ease.raf = requestAnimationFrame(step); }
      } else {
        ease.pos = -1;
        var s = y / (vh * SEG), i = Math.floor(s), f = s - i;
        var t = clamp((f - 0.45) / 0.55, 0, 1);
        var cur = ((i % 4) + 4) % 4;
        blend(cur, (cur + 1) % 4, t * t * (3 - 2 * t));
        if (weather) weather.shift(y - lastY);
      }
      var max = docH - vh;
      bar.style.width = (max > 0 ? Math.min(100, y / max * 100) : 0) + '%';
      lastY = y;
    }
    function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(update); } }

    /* season color for the phone status bar / toolbars and the page canvas (never white) */
    tc = document.querySelector('meta[name="theme-color"]');
    if (!tc) { tc = document.createElement('meta'); tc.name = 'theme-color'; document.head.appendChild(tc); }
    function setChrome(i) { var ch = SEASONS[i].ch; ROOT.style.setProperty('--chrome', ch); tc.setAttribute('content', ch); }
    setChrome(state.dom < 0 ? 0 : state.dom);

    /* grammar for the bag link's screen-reader label after AJAX adds ("1 item", not "1 items") */
    var bagLink = document.querySelector('.mw-nav__icons a[href$="/cart"]');
    function fixBag() { var l = bagLink && bagLink.getAttribute('aria-label'); if (l === 'Bag, 1 items') bagLink.setAttribute('aria-label', 'Bag, 1 item'); }
    if (bagLink && window.MutationObserver) { new MutationObserver(fixBag).observe(bagLink, { attributes: true, attributeFilter: ['aria-label'] }); fixBag(); }

    /* sticky header: ribbon scrolls away, nav pins */
    var ribbon = document.querySelector('.mw-ribbon');
    function ribH() { ROOT.style.setProperty('--rib-h', (ribbon ? ribbon.offsetHeight : 0) + 'px'); }
    ribH(); window.addEventListener('resize', ribH);
    /* close the mobile menu after picking a link */
    document.addEventListener('click', function (e) {
      if (!e.target.closest || !e.target.closest('.mw-nav__drawer a')) return;
      var dr = document.querySelector('.mw-nav__drawer'), btn = document.querySelector('.mw-nav__menu');
      if (dr) dr.removeAttribute('open'); if (btn) btn.setAttribute('aria-expanded', 'false');
    });

    /* if Chrome drops + restores a 2D canvas, nudge its size so the FX engine re-applies its pixel ratio */
    document.querySelectorAll('canvas.mw-fx, canvas.mw-glitter').forEach(function (c) {
      c.addEventListener('contextrestored', function () { c.style.width = '99.9%'; requestAnimationFrame(function () { requestAnimationFrame(function () { c.style.width = ''; }); }); });
    });

    var weather = REDUCE ? null : makeWeather(state);
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    function onMode() { ROOT.classList.toggle('mw-long', isLong()); lastVals = []; ease.pos = -1; onScroll(); }
    if (LONGQ) { if (LONGQ.addEventListener) LONGQ.addEventListener('change', onMode); else if (LONGQ.addListener) LONGQ.addListener(onMode); }
    update();
  }

  /* ---------- pixel weather ---------- */
  function makeWeather(state) {
    var cv = document.createElement('canvas'); cv.className = 'mw-weather'; cv.setAttribute('aria-hidden', 'true');
    document.body.insertBefore(cv, document.body.children[1] || null);
    var ctx = cv.getContext('2d'), W = 0, H = 0, dpr = 1, P = [], N = 0, last = 0, raf = 0;
    /* size to the large viewport and ignore mobile toolbar show/hide, so the canvas never resets mid-scroll */
    var probe = document.createElement('div'); probe.style.cssText = 'position:fixed;top:0;left:0;width:0;height:100vh;height:100lvh;visibility:hidden;pointer-events:none';
    document.body.appendChild(probe);
    function size(force) {
      var nw = window.innerWidth, nh = Math.max(window.innerHeight, probe.offsetHeight || 0);
      if (!force && nw === W && Math.abs(nh - H) < 160) return;
      dpr = Math.min(window.devicePixelRatio || 1, 2); W = nw; H = nh;
      cv.width = Math.round(W * dpr); cv.height = Math.round(H * dpr); cv.style.height = H + 'px';
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0); ctx.imageSmoothingEnabled = false;
      N = Math.round(clamp(W * H / 36000, 16, 44));
      while (P.length < N) P.push(spawn({}, true));
      if (P.length > N) P.length = N;
    }
    function weight(kind) {
      var a = SEASONS[state.cur].k === kind ? 1 - state.t : 0, b = SEASONS[state.nxt].k === kind ? state.t : 0;
      return a + b;
    }
    function spawn(p, anywhere) {
      var kind = SEASONS[Math.random() < state.t ? state.nxt : state.cur].k;
      var z = rand(0.5, 1), rise = kind === 'glint';
      p.k = kind; p.z = z; p.u = z > 0.78 ? 3 : 2;
      p.pi = (Math.random() * SPR[kind].pal.length) | 0;
      p.x = rand(-10, W + 10);
      p.y = anywhere ? rand(0, H) : rise ? H + rand(8, 40) : rand(-40, -8);
      p.a = anywhere ? 0 : 0.01;
      p.ph = rand(0, 6.28);
      if (kind === 'petal') { p.vy = rand(16, 32); p.amp = rand(14, 26); p.fr = rand(0.6, 1.1); }
      else if (kind === 'glint') { p.vy = -rand(8, 18); p.amp = rand(4, 10); p.fr = rand(0.3, 0.6); }
      else if (kind === 'leaf') { p.vy = rand(24, 42); p.amp = rand(26, 46); p.fr = rand(0.5, 0.9); }
      else { p.vy = rand(12, 26); p.amp = rand(8, 18); p.fr = rand(0.35, 0.7); }
      p.vy *= z; p.base = 0.35 + 0.55 * z; p.t0 = rand(0, 100);
      return p;
    }
    function frame(now) {
      raf = requestAnimationFrame(frame);
      var dt = Math.min(0.05, (now - (last || now)) / 1000); last = now;
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0); ctx.imageSmoothingEnabled = false;
      ctx.clearRect(0, 0, W, H);
      for (var i = 0; i < P.length; i++) {
        var p = P[i];
        p.t0 += dt; p.y += p.vy * dt;
        var sx = Math.sin(p.t0 * p.fr * 2 + p.ph), x = p.x + sx * p.amp;
        var tw = p.k === 'glint' ? 0.55 + 0.45 * Math.sin(p.t0 * 3.2 + p.ph) : 1;
        var target = p.base * weight(p.k);
        p.a += (target - p.a) * Math.min(1, dt * 2.2);
        var gone = p.k === 'glint' ? p.y < -30 : p.y > H + 30;
        if (gone || (target === 0 && p.a < 0.02)) { spawn(p, !gone); continue; }
        if (p.a < 0.01) continue;
        var spr = SHEET[p.k][p.pi][p.k === 'leaf' && Math.cos(p.t0 * p.fr * 2 + p.ph) < 0 ? 1 : 0];
        ctx.globalAlpha = p.a * tw;
        ctx.drawImage(spr, Math.round(x), Math.round(p.y), spr.width * p.u, spr.height * p.u);
      }
      ctx.globalAlpha = 1;
    }
    function start() { if (!raf) { last = 0; raf = requestAnimationFrame(frame); } }
    function stop() { if (raf) { cancelAnimationFrame(raf); raf = 0; } }
    size(true); window.addEventListener('resize', function () { size(false); });
    document.addEventListener('visibilitychange', function () { if (document.hidden) stop(); else start(); });
    start();
    return {
      shift: function (dy) {
        if (!dy) return;
        for (var i = 0; i < P.length; i++) { var p = P[i]; p.y -= dy * 0.18 * p.z; if (p.y < -40) p.y += H + 60; else if (p.y > H + 40) p.y -= H + 60; }
      }
    };
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();